import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_right",
  "use": "icon-icon_right-usage",
  "viewBox": "0 0 8 12",
  "content": "<symbol viewBox=\"0 0 8 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon_right\">\n<path d=\"M1.81825 1.63672L6.18188 6.00036L1.81825 10.364\" stroke=\"#969699\" stroke-width=\"2.18182\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol